document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll("form[name='subscribeForm']");
  if (!forms.length) return;

  forms.forEach((form) => {
    const container = form.parentElement.querySelector(".turnstile-container");
    let widgetId;

    const init = () =>
      turnstile.render(container, {
        sitekey: "0x4AAAAAADACVXww7QfY6i7K",
        execution: "execute",
        appearance: "interaction-only",
      });

    if (window.turnstile) {
      widgetId = init();
    } else {
      document.querySelector('script[src*="turnstile"]')?.addEventListener("load", () => {
        widgetId = init();
      });
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn.classList.add("is-loading");

      turnstile.execute(widgetId, {
        callback: async (token) => {
          try {
            await fetch("https://cbx-blog-form.checkbox.workers.dev", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                turnstileToken: token,
                hookId: "69e5dcd5da1db4c5baf44d0c",
                email: form.email.value,
                subscribed: true,
                referrer: document.referrer || "DIRECT",
                landing: location.href,
              }),
            });
            form.parentElement.classList.add("tnx");
            localStorage.setItem("cbx_subscribed", Date.now() + 365 * 24 * 60 * 60 * 1000);
          } finally {
            btn.classList.remove("is-loading");
            turnstile.reset(widgetId);
          }
        },
      });
    });
  });
});
